import gql from 'graphql-tag';

export const GET_INTEGRATION_SETTINGS = gql`
  query GetIntegrationSettings($integrationName: String!) {
    integrationSettings(integrationName: $integrationName) {
      integrationName
      integrationSettings
    }
  }
`;
